import { createStyles, makeStyles } from "@mui/styles"; 
import { Theme } from "@mui/material";

export const HeaderStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1
    },
    logo: {
      marginRight: theme.spacing(2)
    },
    title: {
      flexGrow: 1
    }
  })
);
